import React from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getTokenFromStore } from '../utils/Utils';

const AuthProtected = () => {
    const isTokenAvailable = useSelector((state) => !!getTokenFromStore(state)?.token);
    const location = useLocation();

    if (!isTokenAvailable) {
        /*
         * Redirect to root if not authenticated.
         * In this app, there is no single login URL, so we go to root
         * and let the AuthFlow handle the logic if params are present.
         */
        return <Navigate to="/" state={{ from: location }} />;
    }

    return <Outlet />;
};

export { AuthProtected };
